import isNil from 'lodash/isNil';
import last from 'lodash/last';
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';
import sortBy from 'lodash/sortBy';
import min from 'lodash/min';
import max from 'lodash/max';
import mean from 'lodash/mean';
import round from 'lodash/round';
import isObject from 'lodash/isObject';

import { IDataPointModel } from './model';

export default (self: IDataPointModel) => {
  function getPrecision() {
    return isNil(self.round) ? 3 : self.round;
  }
  function calculate(func) {
    const values = self.measurements.map((measurement) => measurement[1]);
    const value = round(func(values), getPrecision());
    return !Number.isNaN(value) ? value : 'N/A';
  }
  return {
    get _measurements() {
      return sortBy(
        uniqBy(self.measurements, ([ts]: any[]) => ts),
        ([ts]) => ts
      );
    },
    get lastValue() {
      const raw = get(last(self._measurements), '[1]');
      // Metric values can arrive either array-wrapped ([value]) or as a scalar;
      // unwrap the array form so both are handled the same below.
      const value = self.isMetric && Array.isArray(raw) ? raw[0] : raw;
      if (isObject(value) && !Array.isArray(value)) {
        return JSON.stringify(value);
      }
      // Metrics are computed in JS (e.g. a `diff` of metrics), so round to the
      // metric's precision like min/max/avg do — otherwise float noise leaks
      // through (e.g. -7.5999999999999 instead of -7.6). Non-metric values are
      // left untouched (they feed profile-range status classification).
      if (self.isMetric && typeof value === 'number') {
        return round(value, getPrecision());
      }
      // @ts-ignore
      return value;
    },
    get lastTs() {
      // @ts-ignore
      return get(last(self._measurements), '[0]');
    },
    get precision() {
      return getPrecision();
    },
    get min() {
      return calculate(min);
    },
    get max() {
      return calculate(max);
    },
    get avg() {
      return calculate(mean);
    },
    get data() {
      return self.measurements.map(([ts, value]) => (Array.isArray(value) ? [ts, value[0]] : [ts, value]));
    }
  };
};
